//report items
export const SALES_REPORT_ALL_ITEMS = [
    { label: '하트', id: 'heart', key: 'heart' },
    { label: '공동구매', id: 'groupPurchase', key: 'groupPurchase' },
    { label: '79전화', id: 'phone79', key: 'phone79' },
    { label: '일정비', id: 'maintenance', key: 'maintenance' },
    { label: '환불', id: 'refunds', key: 'refunds' },
    { label: '포인트', id: 'point', key: 'point' },
    { label: '총', id: 'total', key: 'total' },
];
export const SALES_REPORT_SINOR_ITEMS = [
    { label: '공동구매', id: 'groupPurchase', key: 'groupPurchase' },
    { label: '79전화', id: 'phone79', key: 'phone79' },
    { label: '일정비', id: 'maintenance', key: 'maintenance' },
    { label: '환불', id: 'refunds', key: 'refunds' },
    { label: '포인트', id: 'point', key: 'point' },
    { label: '총', id: 'total', key: 'total' },
];

export const SALES_REPORT_SILOVE_ITEMS = [
    { label: '하트', id: 'heart', key: 'heart' },
    { label: '79전화', id: 'phone79', key: 'phone79' },
    { label: '환불', id: 'refunds', key: 'refunds' },
    { label: '포인트', id: 'point', key: 'point' },
    { label: '총', id: 'total', key: 'total' },
];

//report chart bar data
export const SALES_REPORT_ALL_BAR_DATA = [
    { dataKey: 'phone79', fill: '#11D70D' },
    { dataKey: 'maintenance', fill: '#3385FF' },
    { dataKey: 'heart', fill: '#FF3388' },
    { dataKey: 'groupPurchase', fill: '#FF7638' },
    { dataKey: 'refunds', fill: '#ad33ff' },
    { dataKey: 'point', fill: '#ff3333' },
];
export const SALES_REPORT_SINOR_BAR_DATA = [
    { dataKey: 'phone79', fill: '#11D70D' },
    { dataKey: 'groupPurchase', fill: '#FF7638' },
    { dataKey: 'maintenance', fill: '#3385FF' },
    { dataKey: 'refunds', fill: '#ad33ff' },
    { dataKey: 'point', fill: '#ff3333' },
];
export const SALES_REPORT_SILOVE_BAR_DATA = [
    { dataKey: 'phone79', fill: '#11D70D' },
    { dataKey: 'heart', fill: '#FF3388' },
    { dataKey: 'refunds', fill: '#ad33ff' },
    { dataKey: 'point', fill: '#ff3333' },
];
